module.exports = __webpack_public_path__ + "img/wpg-home.1197bc78.jpg";